export default function displayFMVs(results) {
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    let s = `<h3>Fair Market Values</h3>`
    if (results.length)
        {
            s+= `<table class="summaryTable  table-responsive ">    
            <thead>
                <th>Year</th> <th>Fair Market Value</th> <th>Total Tax Bill</th> <th>Code</th>
            </thead>`;

            for (let i = 0, il = results.length; i < il; i++) {
                s+=`<tr>
                        <td>${results[i].year}</td><td>${USDollar.format(results[i].fair_property_value)}</td><td>${USDollar.format(results[i].total_tax_bill)}</td><td>${results[i].taxcode}</td>
                    </tr>`
            }
            s += "</table>";

        }
        else {
            s+= `<p>No fair market values to display.</p>`
        }
    return s; 
}